export default __webpack_public_path__ + "static/media/playtable.45ffe6e6.png";